import styles from 'molecules/Image/RichTextImage/image.module.scss';

import Image from '..';

import type { ImageConfig } from 'molecules/Image/config';
import type { FC } from 'react';

const RichTextImage: FC<ImageConfig> = ({ image }) => (
  <>
    {image?.heading && <h5 className={styles.heading}>{image.heading}</h5>}
    <Image {...image} />
  </>
);

export default RichTextImage;
